import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './dish-details.scss';


export default function DishDetailsSubtitle({
    children,
    giftWrapId,
    asHtml = true,
    small = false,
}) {
    const subtitleRootClasses = classNames({
        'ny__details-subtitle__root': true,
        giftSectionDetail: Boolean(giftWrapId),
        small,
    });

    if (asHtml) {
        return (
            <p styleName={subtitleRootClasses} dangerouslySetInnerHTML={{ __html: children }} />
        );
    }

    return (
        <p styleName={subtitleRootClasses}>
            {children}
        </p>
    );
}

DishDetailsSubtitle.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]).isRequired,
    asHtml: PropTypes.bool,
    small: PropTypes.bool,
};

